import { render } from "./ViewOrders.vue?vue&type=template&id=36599706&scoped=true"
import script from "./ViewOrders.vue?vue&type=script&lang=js"
export * from "./ViewOrders.vue?vue&type=script&lang=js"

import "./ViewOrders.vue?vue&type=style&index=0&id=36599706&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36599706"]])

export default __exports__